import { lazyRouteComponent } from "@tanstack/react-router";




const StudyPlan = lazyRouteComponent(() => import("./study-plan.view"));

export const routeOptions = {
  component: StudyPlan,
  head: () => ({
    meta: [
      { title: "Övningsplan – Alkoholprovet" },
      {
        name: "description",
        content: "Planera dina övningstillfällen inför kunskapsprovet.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
};
